<template>
<div>
    <b-tabs v-model="activeTab" class="custom-tabs mt-1">
        <!-- First Tab: Show Table -->

        <b-tab class="custom-tab" title="SUB PROGRAMS">
            <div class="contanior">
                <div class="row">
                    <div class="col-9 pt-3">
                        <div class="ml-2">
                            <span class="p-count">
                                {{ this.subProgramData.length }} Sub Programmes
                            </span>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="p-2 mb-2">
                            <input type="text" placeholder="Search ..." v-model="searchQuerySubProgram" class="form-control" />
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class="col-12 text-right ">
                        <b-button class="mr-2" @click="subProgramCSV">CSV
                            <i class="material-icons">archive</i>
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th v-for="(col, index) in subprogramColumns" :key="index">
                                {{ col.label }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in subProgramFilter" :key="row.id" @click="onFirstTabRowClicked(row)">
                            <td>{{ index + 1 }}</td>
                            <td v-for="col in subprogramColumns" :key="col.key">
                                <template>
                                    {{ row[col.key] }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="contanior" v-if="userRole === 'admin'">
                <div class="row">
                    <div class="col-12 text-center">
                        <span class="add-p" @click="openSubProgramModal">+ Add New Sub Programme</span>
                    </div>
                </div>
            </div>
        </b-tab>

        <!-- Second Tab: Data from first row click -->
        <b-tab title="PROJECTS" :disabled="!projectTitle">
            <div class="contanior">
                <div class="row">
                    <div class="col-9 pt-3">
                        <div class="ml-2">
                            <span class="p-count">
                                {{ this.projectData.length }} Projects
                            </span>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="p-2 mb-2">
                            <input type="text" placeholder="Search ..." v-model="searchQueryProject" class="form-control" />
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class="col-10 ">
                        <div class="ml-2">
                            <span class='ml-1 fz-15'>{{this.projectTitle}}</span>
                        </div>
                    </div>
                    <div class="col-2 text-right">
                        <b-button class="mr-2" @click="projectCSV">CSV
                            <i class="material-icons">archive</i>
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th v-for="(col, index) in projectsColumns" :key="index">
                                {{ col.label }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in projectFilter" :key="row.id" @click="onSecondTabRowClicked(row)">
                            <td>{{ index + 1 }}</td>
                            <td v-for="col in projectsColumns" :key="col.key">
                                <template>
                                    {{ row[col.key] }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="contanior" v-if="userRole === 'admin'">
                <div class="row">
                    <div class="col-12 text-center">
                        <span class="add-p" @click="openProjectModal">+ Add New Project</span>
                    </div>
                </div>
            </div>
        </b-tab>

        <!-- Third Tab: Data from second row click -->
        <b-tab title="TRAININGS" :disabled="!trainingTitle">
            <div class="contanior">
                <div class="row">
                    <div class="col-6 pt-3">
                        <div class="ml-2">
                            <span class="p-count">
                                {{ this.trainingData.length }} Trainings
                            </span>

                        </div>
                    </div>

                    <div class="col-3 pt-2">
                        <div class="form-group date-box">
                            <flat-pickr class="form-control" style="background: #fff;opacity:1" placeholder="Date Range" v-model="dateRange" :config="cardDateOptions"></flat-pickr>
                            <span class="">
                                <button class="btn btn-info btn-reset" @click="resetTrainingFilter(projectId)" v-if="searchendDate !== ''">
                                    Reset
                                </button>
                            </span>
                        </div>

                    </div>
                    <div class="col-3 ">
                        <div class="p-2 mb-2">
                            <input type="text" placeholder="Search ..." v-model="searchQueryTraining" class="form-control" />
                        </div>
                    </div>

                </div>
                <div class='row'>
                    <div class="col-10">
                        <div class="ml-2 fz-15">

                            <span class=''>{{this.projectTitle}} / {{this.trainingTitle}}</span>
                        </div>
                    </div>
                    <div class="col-2 text-right ">
                        <b-button class="mr-2" @click="trainingCSV">CSV
                            <i class="material-icons">archive</i>
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="tb-h">
                <table class="table table-bordered table-striped ">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th v-for="(col, index) in trainingColumns" :key="index">
                                {{ col.label }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in trainingFilter" :key="row.id" @click="showsingletrainingreport(row)">
                            <td>{{ index + 1 }}</td>
                            <td v-for="col in trainingColumns" :key="col.key">

                                <template>
                                    {{ row[col.key] }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="contanior" v-if="userRole === 'admin'">
                    <div class="row">
                        <div class="col-12 text-center">
                            <span class="add-p" @click="openTrainingModal">+ Add New Training</span>
                        </div>
                    </div>
                </div>
            </div>

        </b-tab>
    </b-tabs>
    <!-- Modal to Add New Sub Program -->
    <template>
        <div class="modal-D" v-if="subProgramModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Add Sub Programme</h4>
                        <button type="button" class="close" @click="cancelSubProgram">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <form @submit.prevent="submitSubProgram">
                            <div class="form-group">
                                <label for="subProgramName" class='label-title'>Sub Program <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <input type="text" id="subProgramName" class="form-control" placeholder="Enter Sub Program Title" v-model="newSubProgram.title" />
                            </div>
                            <div class="form-group">
                                <label for="subProgramCode" class='label-title'>Code <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <input type="text" id="subProgramCode" class="form-control" placeholder="Enter Sub Program Code" v-model="newSubProgram.code" />
                            </div>
                            <div class="d-flex justify-content-end">
                                <b-button variant="secondary" @click="cancelSubProgram">Cancel</b-button>
                                <b-button type="submit" variant="success" class='ml-2'>Submit</b-button>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    </template>
    <!-- Modal to Add New Project -->
    <template>
        <div class="modal-D" v-if="projectModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Add Project</h4>
                        <button type="button" class="close" @click="cancelProject">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <form @submit.prevent="submitProject">
                            <div class="form-group">
                                <label for="subProgramCode" class='label-title'>Sub Program <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <selectize id="select-state" class="text-capitalize" v-model="newProject.subprogram_id">
                                    <option v-for="(item, index) in subProgramData" :key="index" :value="item.id" class="text-capitalize">
                                        {{ item.title }}
                                    </option>
                                </selectize>
                            </div>
                            <div class="form-group">
                                <label class='label-title'>Project Code / Agreement Reference <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <input type="text" class="form-control" placeholder="Enter code" v-model="newProject.code" />
                            </div>
                            <div class="form-group">
                                <label for="subProgramCode" class='label-title'>Project Title <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <input type="text" class="form-control" placeholder="Enter title" v-model="newProject.title" />
                            </div>
                            <div class="form-group">
                                <label for="subProgramCode" class='label-title'>Start Date <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <flat-pickr class="form-control" style="background: #fff;font-size:13px" placeholder="Select startdate" v-model="newProject.startDate" :config="dateOptions"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label for="subProgramCode" class='label-title'>End Date <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <flat-pickr class="form-control" style="background: #fff;font-size:13px" placeholder="Select enddate" v-model="newProject.endDate" :config="EnddateOptions"></flat-pickr>
                            </div>
                            <div class="d-flex justify-content-end">
                                <b-button variant="secondary" @click="cancelProject">Cancel</b-button>
                                <b-button type="submit" variant="success" class='ml-2'>Submit</b-button>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    </template>

    <!-- Modal to Add New Training -->
    <template>
        <div class="modal-D" v-if="trainingModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Add Training</h4>
                        <button type="button" class="close" @click="cancelTraining">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <form @submit.prevent="submitTraining">
                            <div class="form-group">
                                <label class='label-title'>Sub Program <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <selectize id="select-state" class="text-capitalize" v-model="newTraining.program_id">
                                    <option v-for="(item, index) in subProgramData" :key="index" :value="item.id" class="text-capitalize">
                                        {{ item.title }}
                                    </option>
                                </selectize>
                            </div>
                            <div class="form-group">
                                <label class='label-title'>Project<span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <selectize id="select-state" class="text-capitalize" v-model="newTraining.project_id">
                                    <option v-for="(item, index) in projectData" :key="index" :value="item.id" class="text-capitalize">
                                        {{ item.title }}
                                    </option>
                                </selectize>
                            </div>
                            <div class="form-group">
                                <label class='label-title'>Assign To Advisor <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <selectize id="select-state" class="text-capitalize" v-model="newTraining.advisor_id">
                                    <option v-for="(item, index) in advisorArr" :key="index" :value="item.id" class="text-capitalize">
                                        {{ item.name }}
                                    </option>
                                </selectize>
                            </div>
                            <div class="form-group">
                                <label class='label-title'>Event Title <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <input type="text" class="form-control" placeholder="Enter Title" v-model="newTraining.trainingtitle" />
                            </div>

                            <div class="d-flex justify-content-end">
                                <b-button variant="secondary" @click="cancelProject">Cancel</b-button>
                                <b-button type="submit" variant="success" class='ml-2'>Submit</b-button>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Selectize from "vue2-selectize";
import {
    subProgrammes,
    projects,
    trainings
} from '../../utils/DownloadCSV'
import {
    formatDate
} from "@/utils/DateFormate";


export default {
    data() {
        return {
            activeTab: 0,
            searchstartDate: '',
            searchendDate: '',
            subProgramData: [],
            projectData: [],
            trainingData: [],
            subprogramColumns: [{
                    label: "Code",
                    key: "code",
                },
                {
                    label: "Title",
                    key: "title",
                },
                {
                    label: "Project Count",
                    key: "count",
                },
            ],
            projectsColumns: [{
                    label: "Code",
                    key: "code",
                },
                {
                    label: "Title",
                    key: "title",
                },
                {
                    label: "Training Count",
                    key: "count",
                },
            ],
            trainingColumns: [{
                    label: "Title",
                    key: "title",
                },
                {
                    label: "Program Officer",
                    key: "po",
                },
                {
                    label: "Advisor",
                    key: "advisor",
                },
                {
                    label: "Donor",
                    key: "doner",
                },
                {
                    label: "Status",
                    key: "status",
                },

                {
                    label: "Start Date",
                    key: "startDate",
                },
                {
                    label: "End Date",
                    key: "endDate",
                },
                {
                    label: "Venue",
                    key: "venue",
                },
                {
                    label: "City",
                    key: "city",
                },
                {
                    label: "Days",
                    key: "days",
                },
                {
                    label: "Post Assesment",
                    key: "postAssesment",
                },
                {
                    label: "Pre Assesment",
                    key: "preAssesment",
                },
            ],
            programOfficerArr: [],
            advisorArr: [],
            donerArr: [],
            cityArr: [],
            searchQuerySubProgram: "",
            searchQueryProject: "",
            searchQueryTraining: "",
            dateRange: [],
            projectId: '',
            programId: '',
            userId: JSON.parse(localStorage.getItem("currentUser")).id,
            userRole: localStorage.getItem("isPermission"),
            cardDateOptions: {
                wrap: true,
                weekNumbers: true,
                mode: "range",
                maxDate: new Date().fp_incr(10),
                dateFormat: "d-m-Y",
            },
            dateOptions: {
                dateFormat: "d-m-Y"
            },
            EnddateOptions: {
                minDate: "today",
                dateFormat: "d-m-Y"
            },
            subProgramModal: false,
            newSubProgram: {
                title: '',
                code: '',
            },
            projectModal: false,
            newProject: {
                subprogram_id: '',
                code: '',
                title: '',
                startDate: '',
                endDate: '',
            },
            projectTitle: '',
            trainingTitle: '',
            trainingModal: false,
            newTraining: {
                program_id: '',
                project_id: '',
                trainingtitle: '',
                advisor_id: '',
            }
        };

    },

    components: {
        flatPickr,
        Selectize
    },
    mounted() {

        this.checkTab();
        this.searchSubProgram();
        this.getProgramofficer();
        this.getAdvisor();
        this.getDoner();
        this.getCity();

    },
    methods: {
        formatDate,
        checkTab() {
            this.openLoading();
            const Project = JSON.parse(sessionStorage.getItem("project"));
            const Training = JSON.parse(sessionStorage.getItem("training"));

            if (Project != null && Training != null) {

                this.showProjects(Project.id);
                this.projectTitle = Project.title;

                this.showTrainings(Training.id);
                this.trainingTitle = Training.title;

                setTimeout(() => {
                    this.activeTab = 2;
                }, 500);
            }
        },
        searchSubProgram() {
            this.openLoading();
            axios
            // .get(localStorage.getItem("BASE_PATH") + "/subprograms/get")
            this.fetchSubprograms()
                .then((response) => {
                    this.closeLoading();
                    this.subProgramData = response.data.map((item) => ({
                        id: item.id,
                        code: item.code,
                        title: item.title,
                        count: item.project.length,
                    }));
                })
                .catch((error) => this.toastError("Error fetching Sub Programs:", error));
        },
        fetchSubprograms() {
            const BASE_PATH = localStorage.getItem("BASE_PATH");
            const userRole = this.userRole;
            const userId = this.userId;

            // Determine the endpoint based on user role
            let endpoint = "";

            switch (userRole) {
                case "admin":
                    endpoint = "/subprograms/get";
                    break;
                case "advisor":
                    endpoint = `/advisor/subprograms/${userId}/get`;
                    break;
                case "program_officer":
                    endpoint = `/program_officer/subprograms/${userId}/get`;
                    break;
                default:
                    throw new Error("Invalid user role");
            }

            // Make the API call
            return axios
                .get(`${BASE_PATH}${endpoint}`)
                .then(response => response)
                .catch(error => {
                    this.toastError("API Error:", error);
                    throw error;
                });
        },
        onFirstTabRowClicked(row) {
            sessionStorage.setItem("project", JSON.stringify(row));
            this.openLoading();
            this.showProjects(row.id);
            this.projectTitle = row.title;
            setTimeout(() => {
                this.activeTab = 1;
                this.closeLoading();
            }, 500);
        },
        showProjects(id) {
            this.openLoading();
            this.programId = id;
            axios
            this.fetchProjects(id)
                .then((response) => {

                    this.projectData = response.data.map((item) => ({
                        id: item.id,
                        code: item.code,
                        title: item.title,
                        count: item.training.length,
                    }));
                })
                .catch((error) => this.toastError("Error fetching Projects:", error));
        },
        fetchProjects(id) {
            const BASE_PATH = localStorage.getItem("BASE_PATH");
            const userRole = this.userRole;
            const userId = this.userId;

            // Determine the endpoint based on user role
            let endpoint = "";

            switch (userRole) {
                case "admin":
                    endpoint = "/subprogram/projects/" + id + "/filter";
                    break;
                case "advisor":
                    endpoint = `/advisor/subprogram/projects/${id}/${userId}/filter`;
                    break;
                case "program_officer":
                    endpoint = `/program_officer/subprogram/projects/${id}/${userId}/filter`;
                    break;
                default:
                    throw new Error("Invalid user role");
            }

            // Make the API call
            return axios
                .get(`${BASE_PATH}${endpoint}`)
                .then(response => response)
                .catch(error => {
                    this.toastError("API Error:", error);
                    throw error;
                });
        },
        onSecondTabRowClicked(row) {
            sessionStorage.setItem("training", JSON.stringify(row));
            this.openLoading();
            this.showTrainings(row.id);
            this.trainingTitle = row.title;
            setTimeout(() => {
                this.activeTab = 2;
            }, 500);
        },
        showTrainings(id) {
            this.openLoading();
            this.projectId = id;
            this.trainingData = [];
            this.dateRange = [];
            axios
            this.fetchTrainings(id)
                .then((response) => {
                    setTimeout(() => {
                        this.closeLoading();
                    }, 500);
                    this.trainingData = response.data.map((item) => ({
                        id: item.id,
                        title: item.title,
                        advisor: this.getAdvisorName(item.advisor_id),
                        po: this.getPOName(item.programofficer_id),
                        doner: this.getDonerName(item.doner_id),
                        status: item.trainingstatus,
                        startDate: this.formatDate(item.startdate),
                        endDate: this.formatDate(item.enddate),
                        venue: item.venue,
                        city: this.getCityName(item.district_id),
                        days: item.noofdays,
                        postAssesment: item.postassesment_status,
                        preAssesment: item.preassesment_status,
                        training_code: item.training_code,
                    }));

                })
                .catch((error) => this.toastError("Error fetching Trainings:", error));
        },
        fetchTrainings(id) {
            const BASE_PATH = localStorage.getItem("BASE_PATH");
            const userRole = this.userRole;
            const userId = this.userId;

            // Determine the endpoint based on user role
            let endpoint = "";

            switch (userRole) {
                case "admin":
                    endpoint = "/project/trainings/" + id + "/filter";
                    break;
                case "advisor":
                    endpoint = `/advisor/project/trainings/filterdate/01-01-2000/30-12-2028/${id}/${userId}`;
                    break;
                case "program_officer":
                    endpoint = `/project/trainings/filterdate/01-01-2000/31-12-2028/${id}/${userId}`;
                    break;
                default:
                    throw new Error("Invalid user role");
            }

            // Make the API call
            return axios
                .get(`${BASE_PATH}${endpoint}`)
                .then(response => response)
                .catch(error => {
                    this.toastError("API Error:", error);
                    throw error;
                });
        },
        fetchTrainingsDateRange(startDate, endDate) {
            const BASE_PATH = localStorage.getItem("BASE_PATH");
            const userRole = this.userRole;
            const userId = this.userId;
            const id = this.projectId;
            // Determine the endpoint based on user role
            let endpoint = "";

            switch (userRole) {
                case "admin":
                    endpoint = `/project/trainings/filterdate/${startDate}/${endDate}/${id}`;
                    break;
                case "advisor":
                    endpoint = `/advisor/project/trainings/filterdate/${startDate}/${endDate}/${id}/${userId}`;
                    break;
                case "program_officer":
                    endpoint = `/program_officer/project/trainings/filterdate/${startDate}/${endDate}/${id}/${userId}`;
                    break;
                default:
                    throw new Error("Invalid user role");
            }

            // Make the API call
            return axios
                .get(`${BASE_PATH}${endpoint}`)
                .then(response => response)
                .catch(error => {
                    this.toastError("API Error:", error);
                    throw error;
                });
        },
        getDoner() {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/donernames/get")
                .then(response => {
                    this.donerArr = response.data;
                });
        },
        getProgramofficer() {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/programofficer/get")
                .then(response => {
                    this.programOfficerArr = response.data;
                });
        },
        getAdvisor() {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/advisor/get")
                .then(response => {
                    this.advisorArr = response.data;
                });
        },
        getCity() {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/districts/get")
                .then(response => {
                    this.cityArr = response.data;
                });
        },

        getAdvisorName(id) {
            const match = this.advisorArr.find((item) => item.id == id);
            return match ? match.name : "N/A";
        },
        getPOName(id) {
            const match = this.programOfficerArr.find((item) => item.id == id);
            return match ? match.name : "N/A";
        },
        getDonerName(id) {
            const match = this.donerArr.find((item) => item.id == id);
            return match ? match.title : "N/A";
        },
        getCityName(id) {
            const match = this.cityArr.find((item) => item.id == id);
            return match ? match.title : "N/A";
        },
        resetTrainingFilter(id) {
            this.showTrainings(id);
            this.searchendDate = '';
            this.searchstartDate = '';
        },
        showsingletrainingreport(item) {
            const userRole = this.userRole;
            const trainingId = item.training_code;
            let path = "";

            // Determine the path based on user role
            switch (userRole) {
                case "admin":
                    path = "/dashboard/admin/training_wizard";
                    break;
                case "program_officer": // Program Officer
                    path = "/dashboard/programOfficer/wizard-completion";
                    break;
                case "advisor":
                    path = "/dashboard/advisor/training-Assignment";
                    break;
                default:
                    this.toastError("Invalid user role");
                    return;
            }

            // Navigate to the determined path with the training ID as a query parameter
            this.$router.push({
                path: path,
                query: {
                    trainingId: trainingId
                }
            });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        submitSubProgram(e) {
            e.preventDefault();

            this.inValid = [];
            if (!this.newSubProgram.title) {
                this.inValid.push("Sub program is required.");
            }
            if (!this.newSubProgram.code) {
                this.inValid.push("Code is required.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(
                        localStorage.getItem("BASE_PATH") + "/sub-program/add",
                        this.newSubProgram
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            this.cancelSubProgram();
                            this.resetForm();
                            this.searchSubProgram();
                            this.toastSuccess(response.data.success);
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        this.toastError(error);
                    });
            }
        },
        openSubProgramModal() {
            this.subProgramModal = true;
        },
        cancelSubProgram() {
            this.subProgramModal = false;
            this.resetForm();
        },
        openProjectModal() {
            this.projectModal = true;
        },
        cancelProject() {
            this.projectModal = false;
            this.resetForm();
        },
        submitProject(e) {
            e.preventDefault();

            this.inValid = [];
            if (!this.newProject.subprogram_id) {
                this.inValid.push("Please select Sub Program.");
            }
            if (!this.newProject.title) {
                this.inValid.push("Project title is required.");
            }
            if (!this.newProject.code) {
                this.inValid.push("Code is required.");
            }
            if (!this.newProject.startDate) {
                this.inValid.push("Start date is required.");
            }
            if (!this.newProject.endDate) {
                this.inValid.push("End date is required.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {

                this.openLoading();
                axios
                    .post(localStorage.getItem("BASE_PATH") + "/project/add", this.newProject, {
                        headers: {
                            Authorization: localStorage.getItem("token"),
                        }
                    })
                    .then(response => {

                        this.closeLoading();
                        if (response.data.success) {
                            this.cancelProject();
                            this.showProjects(this.programId);
                            this.resetForm();
                            this.toastSuccess("Record has been added successfully!");
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.newSubProgram.title = '';
            this.newSubProgram.code = '';
            this.newProject.subprogram_id = '';
            this.newProject.code = '';
            this.newProject.title = '';
            this.newProject.startDate = '';
            this.newProject.endDate = '';
            this.newTraining.program_id = '';
            this.newTraining.project_id = '';
            this.newTraining.trainingtitle = '';
            this.newTraining.advisor_id = '';

        },
        subProgramCSV() {
            subProgrammes(this.subProgramData)
        },
        projectCSV() {
            projects(this.projectData)
        },
        trainingCSV() {
            trainings(this.trainingData)
        },
        openTrainingModal() {
            this.trainingModal = true;
        },
        cancelTraining() {
            this.trainingModal = false;
            this.resetForm();
        },
        submitTraining(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.newTraining.program_id) {
                this.inValid.push("Please select Sub Program.");
            }
            if (!this.newTraining.project_id) {
                this.inValid.push("Please select Project.");
            }
            if (!this.newTraining.trainingtitle) {
                this.inValid.push("Please enter Event Title.");
            }
            if (!this.newTraining.advisor_id) {
                this.inValid.push("Please select Advisor.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }

            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(localStorage.getItem("BASE_PATH") + "/admin/create/training", this.newTraining

                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);

                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data.success) {
                            this.cancelTraining();
                            this.showTrainings(this.projectId);
                            this.resetForm();
                            this.toastSuccess("Record has been added successfully!");
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },

    },
    computed: {
        subProgramFilter() {
            if (!this.searchQuerySubProgram.trim()) {
                return this.subProgramData;
            }
            return this.subProgramData.filter((item) => {
                const searchableFields = `${item.title} ${item.code} ${item.count}`;
                return searchableFields
                    .toLowerCase()
                    .includes(this.searchQuerySubProgram.toLowerCase());
            });
        },

        projectFilter() {
            if (!this.searchQueryProject.trim()) {
                return this.projectData;
            }
            return this.projectData.filter((item) => {
                const searchableFields = `${item.title} ${item.code} ${item.count}`;
                return searchableFields
                    .toLowerCase()
                    .includes(this.searchQueryProject.toLowerCase());
            });
        },

        trainingFilter() {
            if (!this.searchQueryTraining.trim()) {
                return this.trainingData;
            }
            return this.trainingData.filter((item) => {
                const searchableFields = `${item.title} ${item.days}`;
                return searchableFields
                    .toLowerCase()
                    .includes(this.searchQueryTraining.toLowerCase());
            });
        },
    },
    watch: {
        dateRange(date) {
            if (date != undefined && date != "") {
                this.searchstartDate = date.split(" to")[0];
                this.searchendDate = date.split("to ")[1];
                if (
                    this.searchstartDate != undefined &&
                    this.searchendDate != undefined
                ) {
                    this.openLoading();
                    axios

                    this.fetchTrainingsDateRange(this.searchstartDate, this.searchendDate, )
                        .then(response => {
                            this.closeLoading();
                            if (response) {
                                this.trainingData = response.data.map((item) => ({
                                    id: item.id,
                                    title: item.title,
                                    advisor: item.advisor_id,
                                    po: item.programofficer_id,
                                    doner: item.doner_id,
                                    status: item.trainingstatus,
                                    startDate: item.startdate,
                                    endDate: item.enddate,
                                    venue: item.venue,
                                    city: item.district_id,
                                    days: item.noofdays,
                                    postAssesment: item.postassesment_status,
                                    preAssesment: item.preassesment_status,
                                }));
                            }
                        });
                }
            }
        }
    },
};
</script>

<style scoped>
tbody tr:hover {
    cursor: pointer;
    background: #9fdcf7 !important;
}

thead {
    background: #138496;
    color: #ffff
}

.p-count {
    font-size: 16px;
    font-weight: 500;
    background: #d4e891;
    padding: 8px;
    border-radius: 5px;
}

td {
    vertical-align: middle;
}

.bt-box {
    padding-top: 30px;
}

.custom-tabs {
    font-weight: 700 !important;
}

.tb-h {
    height: 70vh;
    overflow: auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 99%;
    margin-left: .5%;
}

.add-p {
    font-size: 16px;
    background: #ffdfbb;
    padding: 7px;
    border-radius: 5px;
    cursor: pointer;
}

.add-p:hover {
    background: #efd9c0;
}

.modal-open .modal {
    background-color: rgba(0, 0, 0, .7) !important;
}

.modal-D {
    position: fixed;
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
}

.label-title {
    font-size: 16px;
    font-weight: 700;
}

.table-responsive {
    width: 99%;
    margin-left: .5%;
}

.date-box {
    position: relative;
}

.btn-reset {
    position: absolute;
    right: 0px;
    top: 0px;
}

.fz-15 {
    font-size: 15px;
}
</style>
